import React from "react";
import { Link } from "react-router-dom";

import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <div className={styles.container}>
      <div className={styles.left_side_container}>
        <a href="#heading">↑ Back to top ↑</a>
        <Link to="/">Return to Home</Link>
      </div>
      <div className={styles.right_side_container}>
        <label>
          <a
            href="https://safiyurrahman.me"
            target="_blank"
          >
            © 2024 Safiyur Rahman
          </a>
        </label>
      </div>
    </div>
  );
}
